import type { ResourceConfig } from "../types";

/**
 * 课程权限配置
 *
 * 课程是培训班的基础数据（课程模板），管理员可修改，其他角色只读
 */
export const courseConfig = {
  displayName: "课程",
  category: "course",
  permissions: {
    "read:all": {
      label: "查看所有课程",
      description: "可以查看系统中所有课程的信息",
    },
    "write:all": {
      label: "编辑所有课程",
      description: "可以创建、编辑、删除课程（仅管理员）",
    },
  },
  // 课程是基础配置，不需要 levels（无 assigned 权限）
  // 注意：导航入口已移除（/courses 页面未实现），权限配置保留供 API 使用
} satisfies ResourceConfig;
